import React, { useState } from "react";
import { UploadDocumentOverlayPartner } from "./utils";
import dropdownIcon from "../../assests/page/contact-dropdown.svg";
import arrowUp from "../../assests/page/contact-arrow-up.svg";
import searchIcon from "../../assests/sideBar/search-icon.svg";
import selectBankCircle from "../../assests/page/select-bank-circle.svg";
import selectBankClicked from "../../assests/page/select-bank-clicked.svg";
import useUserStore from "../../store/userSlice";
import { useTranslation } from "react-i18next";

const PartnerQuestionaireOverlay = (props) => {
  const { t } = useTranslation();
  const { userAddress } = useUserStore();

  const [searchActive, setSearchActive] = useState(false);
  const [newSearchContent, setNewSearchContent] = useState(null);

  const {
    formStates: {
      _kycQuestionaire,
      _setKycQuestionaire,
      partnerUploadPercentageAnnualReport,
      setPartnerUploadPercentageAnnualReport,
      partnerUploadedDocumentHashAnnualReport,
      setPartnerUploadedDocumentHashAnnualReport,
      partnerUploadedDocumentAnnualReport,
      setPartnerUploadedDocumentAnnualReport,
      partnerUploadPercentageAMLPolicy,
      setPartnerUploadPercentageAMLPolicy,
      partnerUploadedDocumentHashAMLPolicy,
      setPartnerUploadedDocumentHashAMLPolicy,
      partnerUploadedDocumentAMLPolicy,
      setPartnerUploadedDocumentAMLPolicy,
      partnerUploadPercentageFATCACRS,
      setPartnerUploadPercentageFATCACRS,
      partnerUploadedDocumentHashFATCACRS,
      setPartnerUploadedDocumentHashFATCACRS,
      partnerUploadedDocumentFATCACRS,
      setPartnerUploadedDocumentFATCACRS,
      partnerUploadPercentageIdOfDirectors,
      setPartnerUploadPercentageIdOfDirectors,
      partnerUploadedDocumentHashIdOfDirectors,
      setPartnerUploadedDocumentHashIdOfDirectors,
      partnerUploadedDocumentIdOfDirectors,
      setPartnerUploadedDocumentIdOfDirectors,
      partnerUploadPercentageSignatoryList,
      setPartnerUploadPercentageSignatoryList,
      partnerUploadedDocumentHashSignatoryList,
      setPartnerUploadedDocumentHashSignatoryList,
      partnerUploadedDocumentSignatoryList,
      setPartnerUploadedDocumentSignatoryList,
      partnerUploadPercentageRegisterOfDirectors,
      setPartnerUploadPercentageRegisterOfDirectors,
      partnerUploadedDocumentHashRegisterOfDirectors,
      setPartnerUploadedDocumentHashRegisterOfDirectors,
      partnerUploadedDocumentRegisterOfDirectors,
      setPartnerUploadedDocumentRegisterOfDirectors,
      partnerUploadPercentageOwnerShipAndCSChart,
      setPartnerUploadPercentageOwnerShipAndCSChart,
      partnerUploadedDocumentHashOwnerShipAndCSChart,
      setPartnerUploadedDocumentHashOwnerShipAndCSChart,
      partnerUploadedDocumentOwnerShipAndCSChart,
      setPartnerUploadedDocumentOwnerShipAndCSChart,
      partnerUploadPercentageArticlesOfAssociation,
      setPartnerUploadPercentageArticlesOfAssociation,
      partnerUploadedDocumentHashArticlesOfAssociation,
      setPartnerUploadedDocumentHashArticlesOfAssociation,
      partnerUploadedDocumentArticlesOfAssociation,
      setPartnerUploadedDocumentArticlesOfAssociation,
      partnerUploadPercentageProofOfRegulation,
      setPartnerUploadPercentageProofOfRegulation,
      partnerUploadedDocumentHashProofOfRegulation,
      setPartnerUploadedDocumentHashProofOfRegulation,
      partnerUploadedDocumentProofOfRegulation,
      setPartnerUploadedDocumentProofOfRegulation,
      partnerUploadPercentageUBO,
      setPartnerUploadPercentageUBO,
      partnerUploadedDocumentHashUBO,
      setPartnerUploadedDocumentHashUBO,
      partnerUploadedDocumentUBO,
      setPartnerUploadedDocumentUBO,
      partnerUploadPercentageUBOSource,
      setPartnerUploadPercentageUBOSource,
      partnerUploadedDocumentHashUBOSource,
      setPartnerUploadedDocumentHashUBOSource,
      partnerUploadedDocumentUBOSource,
      setPartnerUploadedDocumentUBOSource,
      partnerUploadPercentageW8,
      setPartnerUploadPercentageW8,
      partnerUploadedDocumentHashW8,
      setPartnerUploadedDocumentHashW8,
      partnerUploadedDocumentW8,
      setPartnerUploadedDocumentW8,
      partnerInputAddress,
      setPartnerInputAddress,
      partnerInputWebsite,
      setPartnerInputWebsite,
      partnerInputDate,
      setPartnerInputDate,
      partnerInputEmail,
      setPartnerInputEmail,
      partnerInputName,
      setPartnerInputName,
      partnerIdx,
      setPartnerIdx,
      entityType,
      setEntityType,
      partnersDetails,
      setPartnersDetails,
      moreComapnies,
      setMoreCompanies,
      partnerSelectedCountryInc,
      setPartnerSelectedCountryInc,
      countryList,
      setCountryList,
      partnerStep,
      setPartnerStep,
      showPartners,
      setShowPartners,
      isCheckboxClicked,
      setIsCheckboxClicked,
      includeEntity,
      setIncludeEntity,
    },
  } = props;

  return (
    <React.Fragment>
      {partnerStep === "1" && (
        <React.Fragment>
          <p className="verify-kyc-footer-text">
            Do you have another company in your structure?
          </p>
          <div className="profile-edit-contact-body">
            <div className="select-bank-popup">
              <div className="select-bank-popup-container">
                <div className="select-bank-popup-body">
                  <div className="select-bank-popup-body-container">
                    <div
                      onClick={async () => {
                        setMoreCompanies("Yes");
                        setPartnerStep("2");
                      }}
                      className="select-bank-popup-body-content"
                    >
                      <div className="select-bank-popup-body-content-container">
                        <div className="select-bank-popup-body-content-main">
                          <div className="select-bank-popup-body-content-text-container">
                            <p
                              style={{ maxWidth: "300px" }}
                              className="select-bank-popup-body-content-text"
                            >
                              Yes
                            </p>
                          </div>
                          {moreComapnies !== "Yes" && (
                            <img src={selectBankCircle} alt="Checkbox Icon" />
                          )}
                          {moreComapnies === "Yes" && (
                            <img src={selectBankClicked} alt="Checkbox Icon" />
                          )}
                        </div>
                      </div>
                    </div>

                    <div
                      onClick={async () => {
                        setShowPartners(false);
                        setMoreCompanies("No");
                        setPartnerStep("1");
                        setPartnerIdx(-1);
                      }}
                      className="select-bank-popup-body-content"
                    >
                      <div className="select-bank-popup-body-content-container">
                        <div className="select-bank-popup-body-content-main">
                          <div className="select-bank-popup-body-content-text-container">
                            <p
                              style={{ maxWidth: "300px" }}
                              className="select-bank-popup-body-content-text"
                            >
                              No
                            </p>
                          </div>
                          {moreComapnies !== "No" && (
                            <img src={selectBankCircle} alt="Checkbox Icon" />
                          )}
                          {moreComapnies === "No" && (
                            <img src={selectBankClicked} alt="Checkbox Icon" />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )}

      {partnerStep === "2" && moreComapnies === "Yes" && (
        <React.Fragment>
          <p className="verify-kyc-footer-text">Entity Type</p>
          <div className="profile-edit-contact-body">
            <div className="select-bank-popup">
              <div className="select-bank-popup-container">
                <div className="select-bank-popup-body">
                  <div className="select-bank-popup-body-container">
                    <div
                      onClick={async () => {
                        setEntityType("Company");

                        setPartnerStep("3");
                        setIncludeEntity(false);
                        let newPartners = partnersDetails;
                        newPartners[partnerIdx] = {
                          ...newPartners[partnerIdx],
                          entityType: "Company",
                        };
                        setPartnersDetails(newPartners);
                        _setKycQuestionaire((prev) => ({
                          ...prev,
                          partnersDetails: newPartners,
                        }));
                      }}
                      className="select-bank-popup-body-content"
                    >
                      <div className="select-bank-popup-body-content-container">
                        <div className="select-bank-popup-body-content-main">
                          <div className="select-bank-popup-body-content-text-container">
                            <p
                              style={{ maxWidth: "300px" }}
                              className="select-bank-popup-body-content-text"
                            >
                              Company
                            </p>
                          </div>
                          {entityType !== "Company" && (
                            <img src={selectBankCircle} alt="Checkbox Icon" />
                          )}
                          {entityType === "Company" && (
                            <img src={selectBankClicked} alt="Checkbox Icon" />
                          )}
                        </div>
                      </div>
                    </div>

                    <div
                      onClick={async () => {
                        setEntityType("Trust");
                        setPartnerStep("3");
                        setIncludeEntity(false);
                        let newPartners = partnersDetails;
                        newPartners[partnerIdx] = {
                          ...newPartners[partnerIdx],
                          entityType: "Trust",
                        };
                        setPartnersDetails(newPartners);
                        _setKycQuestionaire((prev) => ({
                          ...prev,
                          partnersDetails: newPartners,
                        }));
                      }}
                      className="select-bank-popup-body-content"
                    >
                      <div className="select-bank-popup-body-content-container">
                        <div className="select-bank-popup-body-content-main">
                          <div className="select-bank-popup-body-content-text-container">
                            <p
                              style={{ maxWidth: "300px" }}
                              className="select-bank-popup-body-content-text"
                            >
                              Trust
                            </p>
                          </div>
                          {entityType !== "Trust" && (
                            <img src={selectBankCircle} alt="Checkbox Icon" />
                          )}
                          {entityType === "Trust" && (
                            <img src={selectBankClicked} alt="Checkbox Icon" />
                          )}
                        </div>
                      </div>
                    </div>

                    <div
                      onClick={async () => {
                        setEntityType("Foundation");
                        setPartnerStep("3");
                        setIncludeEntity(false);
                        let newPartners = partnersDetails;

                        newPartners[partnerIdx] = {
                          ...newPartners[partnerIdx],
                          entityType: "Foundation",
                        };
                        setPartnersDetails(newPartners);
                        _setKycQuestionaire((prev) => ({
                          ...prev,
                          partnersDetails: newPartners,
                        }));
                      }}
                      className="select-bank-popup-body-content"
                    >
                      <div className="select-bank-popup-body-content-container">
                        <div className="select-bank-popup-body-content-main">
                          <div className="select-bank-popup-body-content-text-container">
                            <p
                              style={{ maxWidth: "300px" }}
                              className="select-bank-popup-body-content-text"
                            >
                              Foundation
                            </p>
                          </div>
                          {entityType !== "Foundation" && (
                            <img src={selectBankCircle} alt="Checkbox Icon" />
                          )}
                          {entityType === "Foundation" && (
                            <img src={selectBankClicked} alt="Checkbox Icon" />
                          )}
                        </div>
                      </div>
                    </div>

                    <div
                      onClick={async () => {
                        setEntityType("Partnership");
                        setPartnerStep("3");
                        setIncludeEntity(false);
                        let newPartners = partnersDetails;
                        newPartners[partnerIdx] = {
                          ...newPartners[partnerIdx],
                          entityType: "Partnership",
                        };
                        setPartnersDetails(newPartners);
                        _setKycQuestionaire((prev) => ({
                          ...prev,
                          partnersDetails: newPartners,
                        }));
                      }}
                      className="select-bank-popup-body-content"
                    >
                      <div className="select-bank-popup-body-content-container">
                        <div className="select-bank-popup-body-content-main">
                          <div className="select-bank-popup-body-content-text-container">
                            <p
                              style={{ maxWidth: "300px" }}
                              className="select-bank-popup-body-content-text"
                            >
                              Partnership
                            </p>
                          </div>
                          {entityType !== "Partnership" && (
                            <img src={selectBankCircle} alt="Checkbox Icon" />
                          )}
                          {entityType === "Partnership" && (
                            <img src={selectBankClicked} alt="Checkbox Icon" />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )}
      {Number(partnerStep) > 2 && (
        <React.Fragment>
          {includeEntity && (
            <React.Fragment>
              <p className="verify-kyc-footer-text">Entity Type</p>
              <div className="profile-edit-contact-body">
                <div className="select-bank-popup">
                  <div className="select-bank-popup-container">
                    <div className="select-bank-popup-body">
                      <div className="select-bank-popup-body-container">
                        <div
                          onClick={async () => {
                            setEntityType("Company");

                            setPartnerStep("3");
                            let newPartners = partnersDetails;
                            newPartners[partnerIdx] = {
                              ...newPartners[partnerIdx],
                              entityType: "Company",
                            };
                            setPartnersDetails(newPartners);
                            _setKycQuestionaire((prev) => ({
                              ...prev,
                              partnersDetails: newPartners,
                            }));
                          }}
                          className="select-bank-popup-body-content"
                        >
                          <div className="select-bank-popup-body-content-container">
                            <div className="select-bank-popup-body-content-main">
                              <div className="select-bank-popup-body-content-text-container">
                                <p
                                  style={{ maxWidth: "300px" }}
                                  className="select-bank-popup-body-content-text"
                                >
                                  Company
                                </p>
                              </div>
                              {!partnersDetails[partnerIdx]?.entityType && (
                                <React.Fragment>
                                  {entityType !== "Company" && (
                                    <img
                                      src={selectBankCircle}
                                      alt="Checkbox Icon"
                                    />
                                  )}
                                  {entityType === "Company" && (
                                    <img
                                      src={selectBankClicked}
                                      alt="Checkbox Icon"
                                    />
                                  )}
                                </React.Fragment>
                              )}
                              {partnersDetails[partnerIdx]?.entityType && (
                                <React.Fragment>
                                  {partnersDetails[partnerIdx]?.entityType !==
                                    "Company" && (
                                    <img
                                      src={selectBankCircle}
                                      alt="Checkbox Icon"
                                    />
                                  )}
                                  {partnersDetails[partnerIdx]?.entityType ===
                                    "Company" && (
                                    <img
                                      src={selectBankClicked}
                                      alt="Checkbox Icon"
                                    />
                                  )}
                                </React.Fragment>
                              )}
                            </div>
                          </div>
                        </div>

                        <div
                          onClick={async () => {
                            setEntityType("Trust");
                            setPartnerStep("3");
                            let newPartners = partnersDetails;
                            newPartners[partnerIdx] = {
                              ...newPartners[partnerIdx],
                              entityType: "Trust",
                            };
                            setPartnersDetails(newPartners);
                            _setKycQuestionaire((prev) => ({
                              ...prev,
                              partnersDetails: newPartners,
                            }));
                          }}
                          className="select-bank-popup-body-content"
                        >
                          <div className="select-bank-popup-body-content-container">
                            <div className="select-bank-popup-body-content-main">
                              <div className="select-bank-popup-body-content-text-container">
                                <p
                                  style={{ maxWidth: "300px" }}
                                  className="select-bank-popup-body-content-text"
                                >
                                  Trust
                                </p>
                              </div>
                              {!partnersDetails[partnerIdx]?.entityType && (
                                <React.Fragment>
                                  {entityType !== "Trust" && (
                                    <img
                                      src={selectBankCircle}
                                      alt="Checkbox Icon"
                                    />
                                  )}
                                  {entityType === "Trust" && (
                                    <img
                                      src={selectBankClicked}
                                      alt="Checkbox Icon"
                                    />
                                  )}
                                </React.Fragment>
                              )}
                              {partnersDetails[partnerIdx]?.entityType && (
                                <React.Fragment>
                                  {partnersDetails[partnerIdx]?.entityType !==
                                    "Trust" && (
                                    <img
                                      src={selectBankCircle}
                                      alt="Checkbox Icon"
                                    />
                                  )}
                                  {partnersDetails[partnerIdx]?.entityType ===
                                    "Trust" && (
                                    <img
                                      src={selectBankClicked}
                                      alt="Checkbox Icon"
                                    />
                                  )}
                                </React.Fragment>
                              )}
                            </div>
                          </div>
                        </div>

                        <div
                          onClick={async () => {
                            setEntityType("Foundation");
                            setPartnerStep("3");
                            let newPartners = partnersDetails;

                            newPartners[partnerIdx] = {
                              ...newPartners[partnerIdx],
                              entityType: "Foundation",
                            };
                            setPartnersDetails(newPartners);
                            _setKycQuestionaire((prev) => ({
                              ...prev,
                              partnersDetails: newPartners,
                            }));
                          }}
                          className="select-bank-popup-body-content"
                        >
                          <div className="select-bank-popup-body-content-container">
                            <div className="select-bank-popup-body-content-main">
                              <div className="select-bank-popup-body-content-text-container">
                                <p
                                  style={{ maxWidth: "300px" }}
                                  className="select-bank-popup-body-content-text"
                                >
                                  Foundation
                                </p>
                              </div>
                              {!partnersDetails[partnerIdx]?.entityType && (
                                <React.Fragment>
                                  {entityType !== "Foundation" && (
                                    <img
                                      src={selectBankCircle}
                                      alt="Checkbox Icon"
                                    />
                                  )}
                                  {entityType === "Foundation" && (
                                    <img
                                      src={selectBankClicked}
                                      alt="Checkbox Icon"
                                    />
                                  )}
                                </React.Fragment>
                              )}
                              {partnersDetails[partnerIdx]?.entityType && (
                                <React.Fragment>
                                  {partnersDetails[partnerIdx]?.entityType !==
                                    "Foundation" && (
                                    <img
                                      src={selectBankCircle}
                                      alt="Checkbox Icon"
                                    />
                                  )}
                                  {partnersDetails[partnerIdx]?.entityType ===
                                    "Foundation" && (
                                    <img
                                      src={selectBankClicked}
                                      alt="Checkbox Icon"
                                    />
                                  )}
                                </React.Fragment>
                              )}
                            </div>
                          </div>
                        </div>

                        <div
                          onClick={async () => {
                            setEntityType("Partnership");
                            setPartnerStep("3");
                            let newPartners = partnersDetails;
                            newPartners[partnerIdx] = {
                              ...newPartners[partnerIdx],
                              entityType: "Partnership",
                            };
                            setPartnersDetails(newPartners);
                            _setKycQuestionaire((prev) => ({
                              ...prev,
                              partnersDetails: newPartners,
                            }));
                          }}
                          className="select-bank-popup-body-content"
                        >
                          <div className="select-bank-popup-body-content-container">
                            <div className="select-bank-popup-body-content-main">
                              <div className="select-bank-popup-body-content-text-container">
                                <p
                                  style={{ maxWidth: "300px" }}
                                  className="select-bank-popup-body-content-text"
                                >
                                  Partnership
                                </p>
                              </div>
                              {!partnersDetails[partnerIdx]?.entityType && (
                                <React.Fragment>
                                  {entityType !== "Partnership" && (
                                    <img
                                      src={selectBankCircle}
                                      alt="Checkbox Icon"
                                    />
                                  )}
                                  {entityType === "Partnership" && (
                                    <img
                                      src={selectBankClicked}
                                      alt="Checkbox Icon"
                                    />
                                  )}
                                </React.Fragment>
                              )}
                              {partnersDetails[partnerIdx]?.entityType && (
                                <React.Fragment>
                                  {partnersDetails[partnerIdx]?.entityType !==
                                    "Partnership" && (
                                    <img
                                      src={selectBankCircle}
                                      alt="Checkbox Icon"
                                    />
                                  )}
                                  {partnersDetails[partnerIdx]?.entityType ===
                                    "Partnership" && (
                                    <img
                                      src={selectBankClicked}
                                      alt="Checkbox Icon"
                                    />
                                  )}
                                </React.Fragment>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
          {!partnersDetails[partnerIdx]?.entityType && (
            <p className="verify-kyc-footer-text">
              {entityType !== "Partnership" ? entityType : "Partner"} Name
            </p>
          )}
          {partnersDetails[partnerIdx]?.entityType && (
            <p className="verify-kyc-footer-text">
              {partnersDetails[partnerIdx]?.entityType !== "Partnership"
                ? partnersDetails[partnerIdx]?.entityType
                : "Partner"}{" "}
              Name
            </p>
          )}

          <div className="profile-edit-contact-body">
            <input
              name="name-input"
              style={{
                border: "1px solid var(--Neutral-100, #eeeef0)",
                background: "transparent",
                fontWeight: "600",
              }}
              value={partnersDetails[partnerIdx]?.partnerInputName}
              onInput={async (e) => {
                setPartnerInputName(e.target.value);
                // let kycQuestionaireLc =
                //   JSON.parse(
                //     localStorage.getItem(
                //       `${userAddress?.toLowerCase()}-kyc-aml`,
                //     ),
                //   ) || {};
                // kycQuestionaireLc["inputName"] = await encryptKycString(
                //   e.target.value,
                // );

                let newPartners = partnersDetails;
                newPartners[partnerIdx] = {
                  ...newPartners[partnerIdx],
                  partnerInputName: e.target.value,
                };
                setPartnersDetails(newPartners);
                _setKycQuestionaire((prev) => ({
                  ...prev,
                  partnersDetails: newPartners,
                }));

                // localStorage.setItem(
                //   `${userAddress?.toLowerCase()}-kyc-aml`,
                //   JSON.stringify({
                //     ...kycQuestionaireLc,
                //     lastUpdated: Date.now(),
                //   }),
                // );
              }}
              type="text"
              className="offer-security-popup-input"
              placeholder={t("placeholder.enterName")}
            />
          </div>

          <p className="verify-kyc-footer-text">
            {t("kyc.dateOfIncorporation")}
          </p>

          <div className="profile-edit-contact-body">
            <input
              name="name-input"
              style={{
                border: "1px solid var(--Neutral-100, #eeeef0)",
                background: "transparent",
                fontWeight: "600",
                display: "unset",
              }}
              value={partnersDetails[partnerIdx]?.partnerInputDate}
              onInput={async (e) => {
                setPartnerInputDate(e.target.value);
                // let kycQuestionaireLc =
                //   JSON.parse(
                //     localStorage.getItem(
                //       `${userAddress?.toLowerCase()}-kyc-aml`,
                //     ),
                //   ) || {};
                // kycQuestionaireLc["inputDate"] = await encryptKycString(
                //   e.target.value,
                // );

                let newPartners = partnersDetails;
                newPartners[partnerIdx] = {
                  ...newPartners[partnerIdx],
                  partnerInputDate: e.target.value,
                };
                setPartnersDetails(newPartners);
                _setKycQuestionaire((prev) => ({
                  ...prev,
                  partnersDetails: newPartners,
                }));

                // localStorage.setItem(
                //   `${userAddress?.toLowerCase()}-kyc-aml`,
                //   JSON.stringify({
                //     ...kycQuestionaireLc,
                //     lastUpdated: Date.now(),
                //   }),
                // );
              }}
              type="date"
              max="9999-12-31"
              className="offer-security-popup-input"
              placeholder={t("placeholder.enterName")}
            />
          </div>

          <p className="verify-kyc-footer-text">
            {t("kyc.countryOfRegistration")}
          </p>
          <div className="profile-edit-contact-body">
            <div className="profile-edit-contact-content">
              <div className="profile-edit-contact-input-container">
                <div className="profile-edit-contact-input">
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      background: "transparent",
                      border: "1px solid var(--Neutral-100, #eeeef0)",
                    }}
                    onClick={() => {
                      setSearchActive(!searchActive);
                    }}
                    className="profile-edit-contact-first-section"
                  >
                    <div className="profile-edit-contact-selection-icon">
                      {partnersDetails[partnerIdx]?.partnerSelectedCountryInc
                        ?.flag?.length > 0 && (
                        <img
                          onClick={() => {
                            setSearchActive(!searchActive);
                          }}
                          style={{
                            minHeight: "24px",
                            minWidth: "24px",
                          }}
                          alt="Country Flag"
                          src={
                            partnersDetails[partnerIdx]
                              ?.partnerSelectedCountryInc?.flag
                          }
                        />
                      )}
                    </div>
                    <p
                      style={{
                        width: "fit-content",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setSearchActive(!searchActive);
                      }}
                      className="profile-edit-contact-selection-text"
                    >
                      {partnersDetails[partnerIdx]?.partnerSelectedCountryInc
                        ?.name?.length > 0
                        ? partnersDetails[partnerIdx]?.partnerSelectedCountryInc
                            ?.name
                        : "Select Country Of Registration"}
                    </p>

                    {searchActive && (
                      <img
                        onClick={() => {
                          setSearchActive(!searchActive);
                        }}
                        alt="Dropdown Icon"
                        src={arrowUp}
                      />
                    )}
                    {!searchActive && (
                      <img
                        onClick={() => {
                          setSearchActive(!searchActive);
                        }}
                        alt="Dropdown Icon"
                        src={dropdownIcon}
                      />
                    )}
                  </div>
                </div>
                {searchActive && (
                  <>
                    {!countryList && <p>{t("common.loading")}...</p>}
                    {countryList && countryList?.length > 0 && (
                      <div className="mobille-startup-search-box-container">
                        <div className="mobile-startup-search-box">
                          <img
                            src={searchIcon}
                            alt="Search Icon"
                            className="mobile-search-icon"
                          />
                          <input
                            onInput={(e) => {
                              if (e.target.value === "") {
                                setNewSearchContent(null);
                              } else {
                                setNewSearchContent(
                                  countryList?.filter(
                                    // eslint-disable-next-line array-callback-return
                                    (src) => {
                                      if (
                                        src.name
                                          .toLowerCase()
                                          .includes(
                                            e.target.value.toLowerCase(),
                                          )
                                      ) {
                                        src.searched =
                                          e.target.value.toLowerCase();
                                        src.nameArray = src.name.split("");
                                        return src;
                                      }
                                    },
                                  ),
                                );
                              }
                            }}
                            type="text"
                            className="ms-search-box-content"
                            placeholder={t("placeholder.search")}
                          />
                        </div>
                        <div className="mobile-startup-search-content">
                          <div
                            style={
                              props.contentMaxHeight
                                ? {
                                    maxHeight: `${props.contentMaxHeight}px`,
                                  }
                                : {}
                            }
                            className="ms-search-content-container"
                          >
                            {!newSearchContent &&
                              countryList?.length > 0 &&
                              countryList?.map((src, idx) => (
                                <div
                                  key={idx}
                                  onClickCapture={() => {
                                    setPartnerSelectedCountryInc({
                                      area: src?.phone_code,
                                      flag: src?.flag,
                                      name: src.name,
                                      continent: src.continent,
                                      code: src?.code?.toUpperCase(),
                                    });
                                    if (src?.code?.toLowerCase() === "ch") {
                                      setIsCheckboxClicked(false);
                                    }
                                  }}
                                  onClick={() => {
                                    setPartnerSelectedCountryInc({
                                      area: src?.phone_code,
                                      flag: src?.flag,
                                      name: src.name,
                                      continent: src.continent,
                                      code: src?.code?.toUpperCase(),
                                    });
                                    // let kycQuestionaireLc =
                                    //   JSON.parse(
                                    //     localStorage.getItem(
                                    //       `${userAddress?.toLowerCase()}-kyc-aml`,
                                    //     ),
                                    //   ) || {};
                                    // kycQuestionaireLc[
                                    //   "registrationCountry"
                                    // ] = {
                                    //   area: src?.phone_code,
                                    //   flag: src?.flag,
                                    //   name: src.name,
                                    //   continent: src.continent,
                                    //   code: src?.code?.toUpperCase(),
                                    // };

                                    let newPartners = partnersDetails;
                                    newPartners[partnerIdx] = {
                                      ...newPartners[partnerIdx],
                                      partnerSelectedCountryInc: {
                                        area: src?.phone_code,
                                        flag: src?.flag,
                                        name: src.name,
                                        continent: src.continent,
                                        code: src?.code?.toUpperCase(),
                                      },
                                    };
                                    setPartnersDetails(newPartners);
                                    _setKycQuestionaire((prev) => ({
                                      ...prev,
                                      partnersDetails: newPartners,
                                    }));

                                    // localStorage.setItem(
                                    //   `${userAddress?.toLowerCase()}-kyc-aml`,
                                    //   JSON.stringify({
                                    //     ...kycQuestionaireLc,
                                    //     lastUpdated: Date.now(),
                                    //   }),
                                    // );
                                    if (setSearchActive) {
                                      setSearchActive(!searchActive);
                                    }
                                    setNewSearchContent(null);

                                    if (src?.code?.toLowerCase() === "ch") {
                                      setIsCheckboxClicked(false);
                                    }
                                  }}
                                  className="ms-search-content"
                                >
                                  <img
                                    src={src?.flag}
                                    alt="Search Result Icon"
                                    className="ms-search-content-icon"
                                  />
                                  <p className="ms-search-content-text">
                                    {src.name}
                                  </p>
                                </div>
                              ))}

                            {newSearchContent &&
                              newSearchContent.length > 0 &&
                              newSearchContent.map((src, idx) => (
                                <div
                                  key={idx}
                                  onClickCapture={() => {
                                    setPartnerSelectedCountryInc({
                                      area: src?.phone_code,
                                      flag: src?.flag,
                                      name: src.name,
                                      continent: src.continent,
                                      code: src?.code?.toUpperCase(),
                                    });
                                    if (src?.code?.toLowerCase() === "ch") {
                                      setIsCheckboxClicked(false);
                                    }
                                  }}
                                  onClick={() => {
                                    setPartnerSelectedCountryInc({
                                      area: src?.phone_code,
                                      flag: src?.flag,
                                      name: src.name,
                                      continent: src.continent,
                                      code: src?.code?.toUpperCase(),
                                    });
                                    // let kycQuestionaireLc =
                                    //   JSON.parse(
                                    //     localStorage.getItem(
                                    //       `${userAddress?.toLowerCase()}-kyc-aml`,
                                    //     ),
                                    //   ) || {};
                                    // kycQuestionaireLc[
                                    //   "registrationCountry"
                                    // ] = {
                                    //   area: src?.phone_code,
                                    //   flag: src?.flag,
                                    //   name: src.name,
                                    //   continent: src.continent,
                                    //   code: src?.code?.toUpperCase(),
                                    // };

                                    let newPartners = partnersDetails;
                                    newPartners[partnerIdx] = {
                                      ...newPartners[partnerIdx],
                                      partnerSelectedCountryInc: {
                                        area: src?.phone_code,
                                        flag: src?.flag,
                                        name: src.name,
                                        continent: src.continent,
                                        code: src?.code?.toUpperCase(),
                                      },
                                    };
                                    setPartnersDetails(newPartners);
                                    _setKycQuestionaire((prev) => ({
                                      ...prev,
                                      partnersDetails: newPartners,
                                    }));
                                    // localStorage.setItem(
                                    //   `${userAddress?.toLowerCase()}-kyc-aml`,
                                    //   JSON.stringify({
                                    //     ...kycQuestionaireLc,
                                    //     lastUpdated: Date.now(),
                                    //   }),
                                    // );
                                    if (setSearchActive) {
                                      setSearchActive(!searchActive);
                                    }
                                    setNewSearchContent(null);

                                    if (src?.code?.toLowerCase() === "ch") {
                                      setIsCheckboxClicked(false);
                                    }
                                  }}
                                  className="ms-search-content"
                                >
                                  <img
                                    src={src?.flag}
                                    alt="Search Result Icon"
                                    className="ms-search-content-icon"
                                  />
                                  <p className="ms-search-content-text">
                                    {src.nameArray?.length > 0 &&
                                      src.nameArray.map((nm, idx) => (
                                        <>
                                          {!src.searched.includes(
                                            nm.toLowerCase(),
                                          ) && (
                                            <span
                                              key={idx}
                                              style={{
                                                color: "#B6B7C3",
                                              }}
                                            >
                                              {nm}
                                            </span>
                                          )}
                                          {src.searched.includes(
                                            nm.toLowerCase(),
                                          ) && <span key={idx}>{nm}</span>}
                                        </>
                                      ))}
                                  </p>
                                </div>
                              ))}
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>

          <p className="verify-kyc-footer-text">Website</p>

          <div className="profile-edit-contact-body">
            <input
              name="website-input"
              style={{
                border: "1px solid var(--Neutral-100, #eeeef0)",
                background: "transparent",
                fontWeight: "600",
              }}
              value={partnersDetails[partnerIdx]?.partnerInputWebsite}
              onInput={async (e) => {
                setPartnerInputWebsite(e.target.value);
                // let kycQuestionaireLc =
                //   JSON.parse(
                //     localStorage.getItem(
                //       `${userAddress?.toLowerCase()}-kyc-aml`,
                //     ),
                //   ) || {};
                // kycQuestionaireLc["inputWebsite"] =
                //   await encryptKycString(e.target.value);

                let newPartners = partnersDetails;
                newPartners[partnerIdx] = {
                  ...newPartners[partnerIdx],
                  partnerInputWebsite: e.target.value,
                };
                setPartnersDetails(newPartners);
                _setKycQuestionaire((prev) => ({
                  ...prev,
                  partnersDetails: newPartners,
                }));

                // localStorage.setItem(
                //   `${userAddress?.toLowerCase()}-kyc-aml`,
                //   JSON.stringify({
                //     ...kycQuestionaireLc,
                //     lastUpdated: Date.now(),
                //   }),
                // );
              }}
              type="text"
              className="offer-security-popup-input"
              placeholder={t("placeholder.websiteUrl")}
            />
          </div>

          <p className="verify-kyc-footer-text">{t("kyc.registeredAddress")}</p>
          <div className="profile-edit-contact-body">
            <textarea
              name="address-input"
              style={{
                border: "1px solid var(--Neutral-100, #eeeef0)",
                background: "transparent",

                fontWeight: "500",
                minHeight: "60px",
                width: "100%",
              }}
              value={partnersDetails[partnerIdx]?.partnerInputAddress}
              onInput={async (e) => {
                setPartnerInputAddress(e.target.value);
                // let kycQuestionaireLc =
                //   JSON.parse(
                //     localStorage.getItem(
                //       `${userAddress?.toLowerCase()}-kyc-aml`,
                //     ),
                //   ) || {};
                // kycQuestionaireLc["inputAddress"] =
                //   await encryptKycString(e.target.value);

                let newPartners = partnersDetails;
                newPartners[partnerIdx] = {
                  ...newPartners[partnerIdx],
                  partnerInputAddress: e.target.value,
                };
                setPartnersDetails(newPartners);
                _setKycQuestionaire((prev) => ({
                  ...prev,
                  partnersDetails: newPartners,
                }));
                // localStorage.setItem(
                //   `${userAddress?.toLowerCase()}-kyc-aml`,
                //   JSON.stringify({
                //     ...kycQuestionaireLc,
                //     lastUpdated: Date.now(),
                //   }),
                // );
              }}
              type="text"
              className="offer-security-popup-input"
              placeholder={t("placeholder.registeredAddress")}
            ></textarea>
          </div>

          <p className="verify-kyc-footer-text">{t("kyc.emailAddress")}</p>

          <div className="profile-edit-contact-body">
            <input
              name="email-input"
              style={{
                border: "1px solid var(--Neutral-100, #eeeef0)",
                background: "transparent",
                fontWeight: "600",
              }}
              value={partnersDetails[partnerIdx]?.partnerInputEmail}
              onInput={async (e) => {
                setPartnerInputEmail(e.target.value);
                // let kycQuestionaireLc =
                //   JSON.parse(
                //     localStorage.getItem(
                //       `${userAddress?.toLowerCase()}-kyc-aml`,
                //     ),
                //   ) || {};
                // kycQuestionaireLc["inputEmail"] = await encryptKycString(
                //   e.target.value,
                // );

                let newPartners = partnersDetails;
                newPartners[partnerIdx] = {
                  ...newPartners[partnerIdx],
                  partnerInputEmail: e.target.value,
                };
                setPartnersDetails(newPartners);
                _setKycQuestionaire((prev) => ({
                  ...prev,
                  partnersDetails: newPartners,
                }));
                // localStorage.setItem(
                //   `${userAddress?.toLowerCase()}-kyc-aml`,
                //   JSON.stringify({
                //     ...kycQuestionaireLc,
                //     lastUpdated: Date.now(),
                //   }),
                // );
              }}
              type="text"
              className="offer-security-popup-input"
              placeholder={t("placeholder.emailAddress")}
            />
          </div>

          <p
            style={{
              fontWeight: "300",
              display: "flex",
              gap: "8px",
              flexDirection: "column",
              maxWidth: "300px",
              color: "#e23636",
            }}
            className="select-bank-popup-body-content-text"
          >
            <span
              style={{ color: "#e23636" }}
              className="select-bank-popup-body-content-text"
            >
              {t("kyc.certifiedTrueCopyInstruction")}
            </span>

            <span
              style={{ color: "#e23636" }}
              className="select-bank-popup-body-content-text"
            >
              {t("kyc.certifiedTrueCopyDefinition")}
            </span>

            <span
              style={{ color: "#e23636" }}
              className="select-bank-popup-body-content-text"
            >
              {t("kyc.acceptableCertifiers")}
            </span>

            <span
              style={{ background: "black", color: "white" }}
              className="select-bank-popup-body-content-text"
            >
              - {t("kyc.lawyerOrNotary")}
            </span>

            <span
              style={{ background: "black", color: "white" }}
              className="select-bank-popup-body-content-text"
            >
              - {t("kyc.judiciaryOrSeniorCivilServant")}
            </span>

            <span
              style={{ background: "black", color: "white" }}
              className="select-bank-popup-body-content-text"
            >
              - {t("kyc.embassyOfficer")}
            </span>

            <span
              style={{ background: "black", color: "white" }}
              className="select-bank-popup-body-content-text"
            >
              - {t("kyc.actuary")}
            </span>

            <span
              style={{ background: "black", color: "white" }}
              className="select-bank-popup-body-content-text"
            >
              - {t("kyc.accountant")}
            </span>

            <span
              style={{ background: "black", color: "white" }}
              className="select-bank-popup-body-content-text"
            >
              - {t("kyc.instituteOfCharteredSecretaries")}
            </span>

            <span
              style={{ background: "black", color: "white" }}
              className="select-bank-popup-body-content-text"
            >
              - {t("kyc.regulatedFinancialServicesDirector")}
            </span>

            <span
              style={{ color: "#e23636" }}
              className="select-bank-popup-body-content-text"
            >
              The persons above should use the following form of certification:
            </span>
            <span
              style={{ background: "black", color: "white" }}
              className="select-bank-popup-body-content-text"
            >
              {t("kyc.certificationForm")}
            </span>
            <span
              style={{ color: "#e23636" }}
              className="select-bank-popup-body-content-text"
            >
              {t("kyc.certifierRequirements")}
            </span>
            <span
              style={{ background: "black", color: "white" }}
              className="select-bank-popup-body-content-text"
            >
              - {t("kyc.dateAndSignCopy")}
            </span>
            <span
              style={{ background: "black", color: "white" }}
              className="select-bank-popup-body-content-text"
            >
              - {t("kyc.certifierPosition")}
            </span>
            <span
              style={{ background: "black", color: "white" }}
              className="select-bank-popup-body-content-text"
            >
              - {t("kyc.certificationLocation")}
            </span>
            <span
              style={{ background: "black", color: "white" }}
              className="select-bank-popup-body-content-text"
            >
              - {t("kyc.certifierContactDetails")}
            </span>
          </p>

          <React.Fragment>
            <p className="verify-kyc-footer-text">
              Upload filled and signed Form W-8BEN-E
            </p>
            <p
              style={{
                fontWeight: "300",
                display: "flex",
                gap: "8px",
                flexDirection: "column",
                maxWidth: "300px",
              }}
              className="select-bank-popup-body-content-text"
            >
              <span className="select-bank-popup-body-content-text">
                We required by regulator to ask clients to provide W-8BEN-E
                form.
              </span>

              <span
                style={{ color: "blue", cursor: "pointer" }}
                onClick={() => {
                  window.open("https://www.irs.gov/pub/irs-pdf/fw8bene.pdf");
                }}
                className="select-bank-popup-body-content-text"
              >
                Download the Form W-8BEN-E
              </span>

              {/* <span
                      style={{
                        color: "blue",
                        cursor: "pointer",
                        fontWeight: "400",
                      }}
                      onClick={() => {
                        window.open(
                          "https://www.irs.gov/pub/irs-pdf/iw8ben.pdf",
                          selectedUserType !==
                            "Professional / Accredited Individual Investor"
                            ? "https://www.irs.gov/pub/irs-pdf/iw8bene.pdf"
                            : "https://www.irs.gov/pub/irs-pdf/iw8ben.pdf",
                          "_blank",
                        );
                      }}
                      className="select-bank-popup-body-content-text"
                    >
                      {selectedUserType !==
                      "Professional / Accredited Individual Investor"
                        ? "Instructions for Form W-8BEN-E"
                        : "Instructions for Form W-8BEN"}
                    </span> */}
            </p>
            <div className="profile-edit-contact-body">
              <UploadDocumentOverlayPartner
                fileTypes="image/jpg,image/jpeg,image/png,image/heic,image/webp,application/pdf"
                fileTypesText="JPG, PNG, HEIC, WEBP, PDF (max 50 MB)"
                metadataName={userAddress}
                uploadedDocument={partnerUploadedDocumentW8}
                setUploadedDocument={setPartnerUploadedDocumentW8}
                uploadedDocumentHash={partnerUploadedDocumentHashW8}
                setUploadedDocumentHash={setPartnerUploadedDocumentHashW8}
                uploadPercentage={partnerUploadPercentageW8}
                setUploadPercentage={setPartnerUploadPercentageW8}
                inputTagId="w8-input-tag"
                inputTagIdSec="w8-input-tag-sec"
                hashKycName="partnerUploadedDocumentW8"
                docKycName="partnerUploadedDocumentW8Dt"
                setKycQuestionaire={_setKycQuestionaire}
                kycQuestionaireGen={props.KYCQuestionnaire}
                partnersDetails={partnersDetails}
                setPartnersDetails={setPartnersDetails}
                partnerIdx={partnerIdx}
              />
            </div>
          </React.Fragment>

          <p className="verify-kyc-footer-text">
            {t("kyc.sourceOfWealthOfUbo")}(
            <span style={{ color: "#e23636" }}>
              {t("kyc.certifiedTrueCopy")}
            </span>
            )
          </p>
          <p
            style={{
              fontWeight: "300",
              display: "flex",
              gap: "8px",
              flexDirection: "column",
              maxWidth: "300px",
            }}
            className="select-bank-popup-body-content-text"
          >
            <span className="select-bank-popup-body-content-text">
              {t("kyc.sourceOfWealthDescription")}
            </span>
          </p>

          <div className="profile-edit-contact-body">
            <UploadDocumentOverlayPartner
              fileTypes="image/jpg,image/jpeg,image/png,image/heic,image/webp,application/pdf"
              fileTypesText="JPG, PNG, HEIC, WEBP, PDF (max 50 MB)"
              metadataName={userAddress}
              uploadedDocument={partnerUploadedDocumentUBOSource}
              setUploadedDocument={setPartnerUploadedDocumentUBOSource}
              uploadedDocumentHash={partnerUploadedDocumentHashUBOSource}
              setUploadedDocumentHash={setPartnerUploadedDocumentHashUBOSource}
              uploadPercentage={partnerUploadPercentageUBOSource}
              setUploadPercentage={setPartnerUploadPercentageUBOSource}
              inputTagId="ubo-source-input-tag"
              inputTagIdSec="ubo-source-tag-sec"
              hashKycName="partnerUploadedDocumentUBOSource"
              docKycName="partnerUploadedDocumentUBOSourceDt"
              setKycQuestionaire={_setKycQuestionaire}
              kycQuestionaireGen={props.KYCQuestionnaire}
              partnersDetails={partnersDetails}
              setPartnersDetails={setPartnersDetails}
              partnerIdx={partnerIdx}
            />
          </div>

          <React.Fragment>
            <p className="verify-kyc-footer-text">
              {t("kyc.proofOfRegulation")} (
              <span style={{ color: "#e23636" }}>
                {t("kyc.certifiedTrueCopy")}
              </span>
              )
            </p>
            <p
              style={{
                fontWeight: "300",
                display: "flex",
                gap: "8px",
                flexDirection: "column",
                maxWidth: "300px",
              }}
              className="select-bank-popup-body-content-text"
            >
              <span className="select-bank-popup-body-content-text">
                {t("kyc.registrationCertificate")}
              </span>
            </p>
            <div className="profile-edit-contact-body">
              <UploadDocumentOverlayPartner
                fileTypes="image/jpg,image/jpeg,image/png,image/heic,image/webp,application/pdf"
                fileTypesText="JPG, PNG, HEIC, WEBP or PDF (max 50 MB)"
                metadataName={props?.applicantName || userAddress}
                uploadedDocument={partnerUploadedDocumentProofOfRegulation}
                setUploadedDocument={
                  setPartnerUploadedDocumentProofOfRegulation
                }
                uploadedDocumentHash={
                  partnerUploadedDocumentHashProofOfRegulation
                }
                setUploadedDocumentHash={
                  setPartnerUploadedDocumentHashProofOfRegulation
                }
                uploadPercentage={partnerUploadPercentageProofOfRegulation}
                setUploadPercentage={
                  setPartnerUploadPercentageProofOfRegulation
                }
                inputTagId="proofOfRegulation-input-tag"
                inputTagIdSec="proofOfRegulation-input-tag-sec"
                hashKycName="partnerUploadedDocumentProofOfRegulation"
                docKycName="partnerUploadedDocumentProofOfRegulationDt"
                setKycQuestionaire={_setKycQuestionaire}
                kycQuestionaireGen={props.KYCQuestionnaire}
                partnersDetails={partnersDetails}
                setPartnersDetails={setPartnersDetails}
                partnerIdx={partnerIdx}
              />
            </div>

            {!partnersDetails[partnerIdx]?.entityType && (
              <p className="verify-kyc-footer-text">
                {entityType === "Company" || entityType === "Foundation"
                  ? "Articles and / or Memorandum of "
                  : ""}
                {entityType === "Company"
                  ? "Association"
                  : entityType === "Trust"
                    ? "Trust Deed"
                    : entityType === "Foundation"
                      ? "The Foundation"
                      : entityType === "Partnership"
                        ? "Partnership Deed"
                        : ""}{" "}
                (
                <span style={{ color: "#e23636" }}>
                  {t("kyc.certifiedTrueCopy")}
                </span>
                )
              </p>
            )}
            {partnersDetails[partnerIdx]?.entityType && (
              <p className="verify-kyc-footer-text">
                {partnersDetails[partnerIdx]?.entityType === "Company" ||
                partnersDetails[partnerIdx]?.entityType === "Foundation"
                  ? "Articles and / or Memorandum of "
                  : ""}
                {partnersDetails[partnerIdx]?.entityType === "Company"
                  ? "Association"
                  : partnersDetails[partnerIdx]?.entityType === "Trust"
                    ? "Trust Deed"
                    : partnersDetails[partnerIdx]?.entityType === "Foundation"
                      ? "The Foundation"
                      : partnersDetails[partnerIdx]?.entityType ===
                          "Partnership"
                        ? "Partnership Deed"
                        : ""}{" "}
                (
                <span style={{ color: "#e23636" }}>
                  {t("kyc.certifiedTrueCopy")}
                </span>
                )
              </p>
            )}

            <p
              style={{
                fontWeight: "300",
                display: "flex",
                gap: "8px",
                flexDirection: "column",
                maxWidth: "300px",
              }}
              className="select-bank-popup-body-content-text"
            >
              <span className="select-bank-popup-body-content-text">
                {t("kyc.companyDocuments")}
              </span>
            </p>
            <div className="profile-edit-contact-body">
              <UploadDocumentOverlayPartner
                fileTypes="image/jpg,image/jpeg,image/png,image/heic,image/webp,application/pdf"
                fileTypesText="JPG, PNG, HEIC, WEBP or PDF (max 50 MB)"
                metadataName={props?.applicantName || userAddress}
                uploadedDocument={partnerUploadedDocumentArticlesOfAssociation}
                setUploadedDocument={
                  setPartnerUploadedDocumentArticlesOfAssociation
                }
                uploadedDocumentHash={
                  partnerUploadedDocumentHashArticlesOfAssociation
                }
                setUploadedDocumentHash={
                  setPartnerUploadedDocumentHashArticlesOfAssociation
                }
                uploadPercentage={partnerUploadPercentageArticlesOfAssociation}
                setUploadPercentage={
                  setPartnerUploadPercentageArticlesOfAssociation
                }
                inputTagId="articlesOfAssociation-input-tag"
                inputTagIdSec="articlesOfAssociation-input-tag-sec"
                hashKycName="partnerUploadedDocumentArticlesOfAssociation"
                docKycName="partnerUploadedDocumentArticlesOfAssociationDt"
                setKycQuestionaire={_setKycQuestionaire}
                kycQuestionaireGen={props.KYCQuestionnaire}
                partnersDetails={partnersDetails}
                setPartnersDetails={setPartnersDetails}
                partnerIdx={partnerIdx}
              />
            </div>

            {/* <p className="verify-kyc-footer-text">
                      Ownership and Control Structure Chart (
                      <span style={{ color: "#e23636" }}>
                        {t("kyc.certifiedTrueCopy")}
                      </span>
                      )
                    </p>
                    <p
                      style={{
                        fontWeight: "300",
                        display: "flex",
                        gap: "8px",
                        flexDirection: "column",
                        maxWidth: "300px",
                      }}
                      className="select-bank-popup-body-content-text"
                    >
                      <span className="select-bank-popup-body-content-text">
                        A PDF file consisting of Shareholder / Controlling
                        persons' Full Name, Address, Contact number, PAN / DIN /
                        registration number/ identification number and
                        Shareholding %.
                      </span>

                      <span className="select-bank-popup-body-content-text">
                        Signed and dated by a Director or the Company Secretary.
                        Each page of the document to be certified if more than
                        one else, at the end of the document.
                      </span>
                    </p>
                    <div className="profile-edit-contact-body">
                      <UploadDocumentOverlayPartner
                        fileTypes="image/jpg,image/jpeg,image/png,image/heic,image/webp,application/pdf"
                        fileTypesText="JPG, PNG, HEIC, WEBP or PDF (max 50 MB)"
                        metadataName={props?.applicantName || userAddress}
                        uploadedDocument={uploadedDocumentOwnerShipAndCSChart}
                        setUploadedDocument={
                          setUploadedDocumentOwnerShipAndCSChart
                        }
                        uploadedDocumentHash={
                          uploadedDocumentHashOwnerShipAndCSChart
                        }
                        setUploadedDocumentHash={
                          setUploadedDocumentHashOwnerShipAndCSChart
                        }
                        uploadPercentage={uploadPercentageOwnerShipAndCSChart}
                        setUploadPercentage={
                          setUploadPercentageOwnerShipAndCSChart
                        }
                        inputTagId="ownershipAndCSChart-input-tag"
                        inputTagIdSec="ownershipAndCSChart-input-tag-sec"
                        hashKycName="uploadedDocumentOwnerShipAndCSChart"
                        docKycName="uploadedDocumentOwnerShipAndCSChartDt"
                        setKycQuestionaire={_setKycQuestionaire}
                        kycQuestionaireGen={props.KYCQuestionnaire}
                      />
                    </div> */}

            {!partnersDetails[partnerIdx]?.entityType && (
              <p className="verify-kyc-footer-text">
                Register of{" "}
                {entityType === "Company"
                  ? "Directors"
                  : entityType === "Trust"
                    ? "Trustees"
                    : entityType === "Foundation"
                      ? "Members"
                      : entityType === "Partnership"
                        ? "Partners"
                        : ""}{" "}
                (
                <span style={{ color: "#e23636" }}>
                  {t("kyc.certifiedTrueCopy")}
                </span>
                )
              </p>
            )}
            {partnersDetails[partnerIdx]?.entityType && (
              <p className="verify-kyc-footer-text">
                Register of{" "}
                {partnersDetails[partnerIdx]?.entityType === "Company"
                  ? "Directors"
                  : partnersDetails[partnerIdx]?.entityType === "Trust"
                    ? "Trustees"
                    : partnersDetails[partnerIdx]?.entityType === "Foundation"
                      ? "Members"
                      : partnersDetails[partnerIdx]?.entityType ===
                          "Partnership"
                        ? "Partners"
                        : ""}{" "}
                (
                <span style={{ color: "#e23636" }}>
                  {t("kyc.certifiedTrueCopy")}
                </span>
                )
              </p>
            )}

            <p
              style={{
                fontWeight: "300",
                display: "flex",
                gap: "8px",
                flexDirection: "column",
                maxWidth: "300px",
              }}
              className="select-bank-popup-body-content-text"
            >
              <span className="select-bank-popup-body-content-text">
                Signed by a{" "}
                {partnersDetails[partnerIdx]?.entityType &&
                partnersDetails[partnerIdx]?.entityType === "Company"
                  ? "Director"
                  : partnersDetails[partnerIdx]?.entityType &&
                      partnersDetails[partnerIdx]?.entityType === "Trust"
                    ? "Trustee"
                    : partnersDetails[partnerIdx]?.entityType &&
                        partnersDetails[partnerIdx]?.entityType === "Foundation"
                      ? "Member"
                      : partnersDetails[partnerIdx]?.entityType &&
                          partnersDetails[partnerIdx]?.entityType ===
                            "Partnership"
                        ? "Partner"
                        : "Director"}{" "}
                containing the following:
              </span>

              <span className="select-bank-popup-body-content-text">
                {partnersDetails[partnerIdx]?.entityType &&
                partnersDetails[partnerIdx]?.entityType === "Company"
                  ? "Directors"
                  : partnersDetails[partnerIdx]?.entityType &&
                      partnersDetails[partnerIdx]?.entityType === "Trust"
                    ? "Trustees"
                    : partnersDetails[partnerIdx]?.entityType &&
                        partnersDetails[partnerIdx]?.entityType === "Foundation"
                      ? "Members"
                      : partnersDetails[partnerIdx]?.entityType &&
                          partnersDetails[partnerIdx]?.entityType ===
                            "Partnership"
                        ? "Partners"
                        : "Directors"}{" "}
                official full name, date and place of birth, permanent address,
                email-id, identity reference number and nationality.
              </span>

              {/* <span className="select-bank-popup-body-content-text">
                For corporate director we require the full name, email-id,
                registration number, date of incorporation and registered
                address or principal place of business of the corporate entity.
              </span>

              <span className="select-bank-popup-body-content-text">
                For Partnership, provide on the General Partner.
              </span> */}

              <span className="select-bank-popup-body-content-text">
                Each page of the document to be certified if more than one else,
                at the end of the document.
              </span>
            </p>
            <div className="profile-edit-contact-body">
              <UploadDocumentOverlayPartner
                fileTypes="image/jpg,image/jpeg,image/png,image/heic,image/webp,application/pdf"
                fileTypesText="JPG, PNG, HEIC, WEBP or PDF (max 50 MB)"
                metadataName={props?.applicantName || userAddress}
                uploadedDocument={partnerUploadedDocumentRegisterOfDirectors}
                setUploadedDocument={
                  setPartnerUploadedDocumentRegisterOfDirectors
                }
                uploadedDocumentHash={
                  partnerUploadedDocumentHashRegisterOfDirectors
                }
                setUploadedDocumentHash={
                  setPartnerUploadedDocumentHashRegisterOfDirectors
                }
                uploadPercentage={partnerUploadPercentageRegisterOfDirectors}
                setUploadPercentage={
                  setPartnerUploadPercentageRegisterOfDirectors
                }
                inputTagId="registerOfDirectors-input-tag"
                inputTagIdSec="registerOfDirectors-input-tag-sec"
                hashKycName="partnerUploadedDocumentRegisterOfDirectors"
                docKycName="partnerUploadedDocumentRegisterOfDirectorsDt"
                setKycQuestionaire={_setKycQuestionaire}
                kycQuestionaireGen={props.KYCQuestionnaire}
                partnersDetails={partnersDetails}
                setPartnersDetails={setPartnersDetails}
                partnerIdx={partnerIdx}
              />
            </div>

            <p className="verify-kyc-footer-text">
              {t("kyc.authorisedSignatoryList")}(
              <span style={{ color: "#e23636" }}>
                {t("kyc.certifiedTrueCopy")}
              </span>
              )
            </p>
            <p
              style={{
                fontWeight: "300",
                display: "flex",
                gap: "8px",
                flexDirection: "column",
                maxWidth: "300px",
              }}
              className="select-bank-popup-body-content-text"
            >
              <span className="select-bank-popup-body-content-text">
                {t("kyc.authorisedSignatoryPdf")} (Signature Samples of the
                authorized person of the{" "}
                {partnersDetails[partnerIdx]?.entityType &&
                partnersDetails[partnerIdx]?.entityType === "Company"
                  ? "company"
                  : partnersDetails[partnerIdx]?.entityType &&
                      partnersDetails[partnerIdx]?.entityType === "Trust"
                    ? "trust"
                    : partnersDetails[partnerIdx]?.entityType &&
                        partnersDetails[partnerIdx]?.entityType === "Foundation"
                      ? "foundation"
                      : partnersDetails[partnerIdx]?.entityType &&
                          partnersDetails[partnerIdx]?.entityType ===
                            "Partnership"
                        ? "partnership"
                        : "company"}{" "}
                for doing signature on behalf of the{" "}
                {partnersDetails[partnerIdx]?.entityType &&
                partnersDetails[partnerIdx]?.entityType === "Company"
                  ? "company"
                  : partnersDetails[partnerIdx]?.entityType &&
                      partnersDetails[partnerIdx]?.entityType === "Trust"
                    ? "trust"
                    : partnersDetails[partnerIdx]?.entityType &&
                        partnersDetails[partnerIdx]?.entityType === "Foundation"
                      ? "foundation"
                      : partnersDetails[partnerIdx]?.entityType &&
                          partnersDetails[partnerIdx]?.entityType ===
                            "Partnership"
                        ? "partnership"
                        : "company"}
                ).
              </span>

              <span className="select-bank-popup-body-content-text">
                Signed by a{" "}
                {partnersDetails[partnerIdx]?.entityType &&
                partnersDetails[partnerIdx]?.entityType === "Company"
                  ? "Director"
                  : partnersDetails[partnerIdx]?.entityType &&
                      partnersDetails[partnerIdx]?.entityType === "Trust"
                    ? "Trustee"
                    : partnersDetails[partnerIdx]?.entityType &&
                        partnersDetails[partnerIdx]?.entityType === "Foundation"
                      ? "Member"
                      : partnersDetails[partnerIdx]?.entityType &&
                          partnersDetails[partnerIdx]?.entityType ===
                            "Partnership"
                        ? "Partner"
                        : "Director"}{" "}
                including samples of all signatures and the details of any
                signing protocol.
              </span>

              <span className="select-bank-popup-body-content-text">
                Each page of the document to be certified if more than one else,
                at the end of the document.
              </span>
            </p>
            <div className="profile-edit-contact-body">
              <UploadDocumentOverlayPartner
                fileTypes="image/jpg,image/jpeg,image/png,image/heic,image/webp,application/pdf"
                fileTypesText="JPG, PNG, HEIC, WEBP or PDF (max 50 MB)"
                metadataName={props?.applicantName || userAddress}
                uploadedDocument={partnerUploadedDocumentSignatoryList}
                setUploadedDocument={setPartnerUploadedDocumentSignatoryList}
                uploadedDocumentHash={partnerUploadedDocumentHashSignatoryList}
                setUploadedDocumentHash={
                  setPartnerUploadedDocumentHashSignatoryList
                }
                uploadPercentage={partnerUploadPercentageSignatoryList}
                setUploadPercentage={setPartnerUploadPercentageSignatoryList}
                inputTagId="signatoryList-input-tag"
                inputTagIdSec="signatoryList-input-tag-sec"
                hashKycName="partnerUploadedDocumentSignatoryList"
                docKycName="partnerUploadedDocumentSignatoryListDt"
                setKycQuestionaire={_setKycQuestionaire}
                kycQuestionaireGen={props.KYCQuestionnaire}
                partnersDetails={partnersDetails}
                setPartnersDetails={setPartnersDetails}
                partnerIdx={partnerIdx}
              />
            </div>

            <p className="verify-kyc-footer-text">
              {t("kyc.ultimateBeneficialOwnerDeclaration")}(
              <span style={{ color: "#e23636" }}>
                {t("kyc.certifiedTrueCopy")}
              </span>
              )
            </p>
            <p
              style={{
                fontWeight: "300",
                display: "flex",
                gap: "8px",
                flexDirection: "column",
                maxWidth: "300px",
              }}
              className="select-bank-popup-body-content-text"
            >
              <span className="select-bank-popup-body-content-text">
                Beneficiaries owning directly or indirectly 10% or more of the{" "}
                {partnersDetails[partnerIdx]?.entityType &&
                partnersDetails[partnerIdx]?.entityType === "Company"
                  ? "company"
                  : partnersDetails[partnerIdx]?.entityType &&
                      partnersDetails[partnerIdx]?.entityType === "Trust"
                    ? "trust"
                    : partnersDetails[partnerIdx]?.entityType &&
                        partnersDetails[partnerIdx]?.entityType === "Foundation"
                      ? "foundation"
                      : partnersDetails[partnerIdx]?.entityType &&
                          partnersDetails[partnerIdx]?.entityType ===
                            "Partnership"
                        ? "partnership"
                        : "company"}
                . Declaration Form to be filled for each UBO here separately.
              </span>

              <span className="select-bank-popup-body-content-text">
                Please fill, be dated and signed by authorized signatories of
                the{" "}
                {partnersDetails[partnerIdx]?.entityType &&
                partnersDetails[partnerIdx]?.entityType === "Company"
                  ? "company"
                  : partnersDetails[partnerIdx]?.entityType &&
                      partnersDetails[partnerIdx]?.entityType === "Trust"
                    ? "trust"
                    : partnersDetails[partnerIdx]?.entityType &&
                        partnersDetails[partnerIdx]?.entityType === "Foundation"
                      ? "foundation"
                      : partnersDetails[partnerIdx]?.entityType &&
                          partnersDetails[partnerIdx]?.entityType ===
                            "Partnership"
                        ? "partnership"
                        : "company"}{" "}
                and upload here.
              </span>

              <a
                style={{ color: "blue", cursor: "pointer" }}
                target="_blank"
                rel="noreferrer"
                href="https://verified-kyc.s3.amazonaws.com/Ultimate+Beneficial+Owner+(UBO)+Declaration.docx"
                className="select-bank-popup-body-content-text"
              >
                {t("kyc.downloadUboForm")}
              </a>
            </p>
            <div className="profile-edit-contact-body">
              <UploadDocumentOverlayPartner
                fileTypes="image/jpg,image/jpeg,image/png,image/heic,image/webp,application/pdf"
                fileTypesText="JPG, PNG, HEIC, WEBP or PDF (max 50 MB)"
                metadataName={props?.applicantName || userAddress}
                uploadedDocument={partnerUploadedDocumentUBO}
                setUploadedDocument={setPartnerUploadedDocumentUBO}
                uploadedDocumentHash={partnerUploadedDocumentHashUBO}
                setUploadedDocumentHash={setPartnerUploadedDocumentHashUBO}
                uploadPercentage={partnerUploadPercentageUBO}
                setUploadPercentage={setPartnerUploadPercentageUBO}
                inputTagId="ubo-input-tag"
                inputTagIdSec="ubo-input-tag-sec"
                hashKycName="partnerUploadedDocumentUBO"
                docKycName="partnerUploadedDocumentUBODt"
                setKycQuestionaire={_setKycQuestionaire}
                kycQuestionaireGen={props.KYCQuestionnaire}
                partnersDetails={partnersDetails}
                setPartnersDetails={setPartnersDetails}
                partnerIdx={partnerIdx}
              />
            </div>

            {/* <p className="verify-kyc-footer-text">
                      Certified and Valid IDs of the Directors / Authorised
                      signatories / Beneficial Owners / Controlling Persons (
                      <span style={{ color: "#e23636" }}>
                        {t("kyc.certifiedTrueCopy")}
                      </span>
                      )
                    </p>

                    <div className="profile-edit-contact-body">
                      <UploadDocumentOverlayPartner
                        fileTypes="image/jpg,image/jpeg,image/png,image/heic,image/webp,application/pdf"
                        fileTypesText="JPG, PNG, HEIC, WEBP or PDF (max 50 MB)"
                        metadataName={props?.applicantName || userAddress}
                        uploadedDocument={uploadedDocumentIdOfDirectors}
                        setUploadedDocument={setUploadedDocumentIdOfDirectors}
                        uploadedDocumentHash={uploadedDocumentHashIdOfDirectors}
                        setUploadedDocumentHash={
                          setUploadedDocumentHashIdOfDirectors
                        }
                        uploadPercentage={uploadPercentageIdOfDirectors}
                        setUploadPercentage={setUploadPercentageIdOfDirectors}
                        inputTagId="idOfDirectors-input-tag"
                        inputTagIdSec="idOfDirectors-input-tag-sec"
                        hashKycName="uploadedDocumentIdOfDirectors"
                        docKycName="uploadedDocumentIdOfDirectorsDt"
                        setKycQuestionaire={_setKycQuestionaire}
                        kycQuestionaireGen={props.KYCQuestionnaire}
                        isMulitple={true}
                      />
                    </div> */}

            <p className="verify-kyc-footer-text">
              {t("kyc.fatcaCrsSelfCertification")}
            </p>
            <p
              style={{
                fontWeight: "300",
                display: "flex",
                gap: "8px",
                flexDirection: "column",
                maxWidth: "300px",
              }}
              className="select-bank-popup-body-content-text"
            >
              <span className="select-bank-popup-body-content-text">
                {t("kyc.fillAndUpload")}
              </span>

              <a
                style={{ color: "blue", cursor: "pointer" }}
                target="_blank"
                rel="noreferrer"
                href="https://verified-kyc.s3.amazonaws.com/FATCA-CRS-Self-Certification+form+for+Controlling+Person.docx"
                className="select-bank-popup-body-content-text"
              >
                {t("kyc.downloadFatcaCrsForm")}
              </a>
            </p>
            <div className="profile-edit-contact-body">
              <UploadDocumentOverlayPartner
                fileTypes="image/jpg,image/jpeg,image/png,image/heic,image/webp,application/pdf"
                fileTypesText="JPG, PNG, HEIC, WEBP or PDF (max 50 MB)"
                metadataName={props?.applicantName || userAddress}
                uploadedDocument={partnerUploadedDocumentFATCACRS}
                setUploadedDocument={setPartnerUploadedDocumentFATCACRS}
                uploadedDocumentHash={partnerUploadedDocumentHashFATCACRS}
                setUploadedDocumentHash={setPartnerUploadedDocumentHashFATCACRS}
                uploadPercentage={partnerUploadPercentageFATCACRS}
                setUploadPercentage={setPartnerUploadPercentageFATCACRS}
                inputTagId="fatcaCrs-input-tag"
                inputTagIdSec="fatcaCrs-input-tag-sec"
                hashKycName="partnerUploadedDocumentFATCACRS"
                docKycName="partnerUploadedDocumentFATCACRSDt"
                setKycQuestionaire={_setKycQuestionaire}
                kycQuestionaireGen={props.KYCQuestionnaire}
                partnersDetails={partnersDetails}
                setPartnersDetails={setPartnersDetails}
                partnerIdx={partnerIdx}
              />
            </div>

            {/* {selectedUserType === "Institutional Investor" && (
              <React.Fragment>
                <p className="verify-kyc-footer-text">
                  AML policy and procedures of the company / Original AML letter
                </p>

                <div className="profile-edit-contact-body">
                  <UploadDocumentOverlayPartner
                    fileTypes="image/jpg,image/jpeg,image/png,image/heic,image/webp,application/pdf"
                    fileTypesText="JPG, PNG, HEIC, WEBP or PDF (max 50 MB)"
                    metadataName={props?.applicantName || userAddress}
                    uploadedDocument={partnerUploadedDocumentAMLPolicy}
                    setUploadedDocument={setPartnerUploadedDocumentAMLPolicy}
                    uploadedDocumentHash={partnerUploadedDocumentHashAMLPolicy}
                    setUploadedDocumentHash={
                      setPartnerUploadedDocumentHashAMLPolicy
                    }
                    uploadPercentage={partnerUploadPercentageAMLPolicy}
                    setUploadPercentage={setPartnerUploadPercentageAMLPolicy}
                    inputTagId="amlPolicy-input-tag"
                    inputTagIdSec="amlPolicy-input-tag-sec"
                    hashKycName="uploadedDocumentAMLPolicy"
                    docKycName="uploadedDocumentAMLPolicyDt"
                    setKycQuestionaire={_setKycQuestionaire}
                    kycQuestionaireGen={props.KYCQuestionnaire}
                      partnersDetails={partnersDetails}
    setPartnersDetails={setPartnersDetails}
    partnerIdx={partnerIdx}
                  />
                </div>
              </React.Fragment>
            )} */}

            <p className="verify-kyc-footer-text">
              {t("kyc.latestAuditedAnnualReport")}
            </p>
            <p
              style={{
                fontWeight: "300",
                display: "flex",
                gap: "8px",
                flexDirection: "column",
                maxWidth: "300px",
              }}
              className="select-bank-popup-body-content-text"
            >
              <span className="select-bank-popup-body-content-text">
                Please upload Latest audited annual report/financial statements
                and proof of business activity of the{" "}
                {partnersDetails[partnerIdx]?.entityType &&
                partnersDetails[partnerIdx]?.entityType === "Company"
                  ? "company"
                  : partnersDetails[partnerIdx]?.entityType &&
                      partnersDetails[partnerIdx]?.entityType === "Trust"
                    ? "trust"
                    : partnersDetails[partnerIdx]?.entityType &&
                        partnersDetails[partnerIdx]?.entityType === "Foundation"
                      ? "foundation"
                      : partnersDetails[partnerIdx]?.entityType &&
                          partnersDetails[partnerIdx]?.entityType ===
                            "Partnership"
                        ? "partnership"
                        : "company"}{" "}
                – if not available in the audited annual report and/or financial
                statements.
              </span>

              <span className="select-bank-popup-body-content-text">OR</span>

              <span className="select-bank-popup-body-content-text">
                Provide a declaration on{" "}
                {partnersDetails[partnerIdx]?.entityType &&
                partnersDetails[partnerIdx]?.entityType === "Company"
                  ? "company"
                  : partnersDetails[partnerIdx]?.entityType &&
                      partnersDetails[partnerIdx]?.entityType === "Trust"
                    ? "trust"
                    : partnersDetails[partnerIdx]?.entityType &&
                        partnersDetails[partnerIdx]?.entityType === "Foundation"
                      ? "foundation"
                      : partnersDetails[partnerIdx]?.entityType &&
                          partnersDetails[partnerIdx]?.entityType ===
                            "Partnership"
                        ? "partnership"
                        : "company"}{" "}
                letter head with a reason for non-availability.
              </span>
            </p>
            <div className="profile-edit-contact-body">
              <UploadDocumentOverlayPartner
                fileTypes="image/jpg,image/jpeg,image/png,image/heic,image/webp,application/pdf"
                fileTypesText="JPG, PNG, HEIC, WEBP or PDF (max 50 MB)"
                metadataName={props?.applicantName || userAddress}
                uploadedDocument={partnerUploadedDocumentAnnualReport}
                setUploadedDocument={setPartnerUploadedDocumentAnnualReport}
                uploadedDocumentHash={partnerUploadedDocumentHashAnnualReport}
                setUploadedDocumentHash={
                  setPartnerUploadedDocumentHashAnnualReport
                }
                uploadPercentage={partnerUploadPercentageAnnualReport}
                setUploadPercentage={setPartnerUploadPercentageAnnualReport}
                inputTagId="annualReport-input-tag"
                inputTagIdSec="annualReport-input-tag-sec"
                hashKycName="partnerUploadedDocumentAnnualReport"
                docKycName="partnerUploadedDocumentAnnualReportDt"
                setKycQuestionaire={_setKycQuestionaire}
                kycQuestionaireGen={props.KYCQuestionnaire}
                partnersDetails={partnersDetails}
                setPartnersDetails={setPartnersDetails}
                partnerIdx={partnerIdx}
              />
            </div>
          </React.Fragment>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default PartnerQuestionaireOverlay;
